<header>
    <div class="px-5 pt-2">
        <div class="grid align-items-center">
            <!-- Logo Section -->
            <div class="col-4 md:col-6">
                <img [src]="headerLogo" alt="logo" height="90" width="140" style="cursor:pointer"
                    (click)="goToDashboard()" />
            </div>

            <!-- Notification & Profile Section -->
            @if (isLoggedIn()) {
            <div class="col-8 md:col-6">
                <div class="flex justify-content-end align-items-center gap-3" id="headerDocumentsIntro">
                    <span [ngClass]="!isinterested ? 'text-yellow' : ''">My & public documents</span>
                    <p-toggleswitch [(ngModel)]="isinterested" class="yellow-toggle"
                        (onChange)="onInterestedToggleChange($event)" />
                    <span [ngClass]="isinterested ? 'text-yellow' : ''">Only my documents</span>
                    <div class="vertical-divider"></div>
                    <span class="font-medium">{{ userFullName() }}</span>
                    <!-- <img src="/assets/images/user_header.svg" (click)="openThemeCustomize()" alt="Profile"
                             class="w-2rem h-2rem border-circle object-cover cursor-pointer customizer-image" /> -->
                    <span
                        class="flex justify-content-center text-yellow-400 border-circle object-cover cursor-pointer align-items-center customizer-image font-bold user-initials"
                        style="width: 35px; height: 35px;" (click)="openThemeCustomize()">{{ userInitials }}</span>
                </div>
            </div>
            <input type="hidden" id="userId" class="userId" value="{{ userId() }}" />
            <input type="hidden" id="userFullName" class="userFullName" value="{{ userFullName() }}" />
            <input type="hidden" id="email" class="email" value="{{ email() }}" />
            <input type="hidden" id="roleId" class="roleId" value="{{ roleId() }}" />
            <input type="hidden" id="userRoleName" class="userRoleName" value="{{ userRoleName() }}" />
            <input type="hidden" id="entityId" class="entityId" value="{{ entityId() }}" />
            } @else {
            <div class="col-8 md:col-6">
                <div class="flex justify-content-end align-items-center gap-3">
                    <!-- <button pButton type="button" label="Contact" class="contact">
                    </button> -->
                    <button pButton type="button" label="Login" class="login-btn" (click)="goToLogin()">
                    </button>

                </div>
            </div>
            }

            <!-- Theme customizer box -->
            @if (openThemeCustomizer) {
            <div class="flex justify-content-end w-full z-3" #customizerBox>
                <div class="card theme-customize-card">
                    <div class="card-header p-0">
                        <div class="px-3 py-2 admin-section text-center">
                            <p>{{ userFullName() }}</p>
                            <span>{{ userRoleName() }}</span>
                        </div>
                    </div>

                    <div class="card-body p-0 text-center">
                        <div class="p-2 flex justify-content-between">
                            <a href="/profile" class="mb-1 profile-action">
                                <i class="pi pi-user"></i>
                            </a>
                            <a class="mb-1 profile-action" href="javascript:void(0);" (click)="logOutUser()">
                                <i class="pi pi-sign-out"></i>
                            </a>
                        </div>

                        <!-- <div class="px-3 py-2 theme-variation-section">
                            <span>Theme Variation</span>
                        </div> -->

                        <!-- <div class="card px-2 py-3">
                            <div class="flex justify-content-between">
                                @for (theme of themeOption; track theme.key) {
                                <div class="field-checkbox mb-0">
                                    <p-radiobutton [inputId]="theme.key" name="theme" [value]="theme"
                                        [(ngModel)]="selectedThemeOption" (onClick)="onThemeChange(theme.key, theme)" />
                                    <label [for]="theme.key">
                                        <i [class]="theme.icon" class="cursor-pointer" [ngClass]="{
                            'active-icon': selectedThemeOption?.key === theme.key
                          }"></i>
                                    </label>
                                </div>
                                }
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</header>